// Sequential scroll-reveal for the "how it works" steps.
// .lw-steps--init is added by JS only, so with JS disabled nothing is ever hidden.
(function () {
  document.querySelectorAll('.lw-steps').forEach(function (section) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    section.classList.add('lw-steps--init');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('lw-steps--in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );
    io.observe(section);
  });
})();
